import Layout from './modules/Layout.js';

new Layout('category-page');
